
import { useNavigate } from 'react-router-dom';

export default function TermsPage() {
  const navigate = useNavigate();

  const sections = [
    {
      number: '01',
      title: 'Acceptance of Terms',
      body: 'By submitting this form, you ("Client") acknowledge that you have read, understood, and agree to be bound by these Terms & Conditions set forth by Yasmine Creates ("Company"). Submission of this form constitutes acceptance of all terms outlined herein.',
    },
    {
      number: '02',
      title: 'Hosting Requirement',
      body: 'All websites designed and delivered by Yasmine Creates require an active hosting plan to remain published, live, and accessible on the internet. Hosting plans are available on a monthly basis at $59.99/month or an annual basis at $499.99/year. Failure to maintain an active hosting plan will result in the website being taken offline and rendered inaccessible to all visitors and customers. Yasmine Creates does not build or deliver websites without an accompanying hosting agreement. Clients who are unwilling or unable to commit to a hosting plan are ineligible for services.',
    },
    {
      number: '03',
      title: 'Scope of Services',
      body: 'Yasmine Creates provides website design and hosting services exclusively. The Company does not offer website redesigns, migrations, or modifications to websites built on third-party platforms outside of Yasmine Creates. All websites are designed, built, and hosted solely by Yasmine Creates. The Company reserves the right to decline any project deemed outside the scope of deliverable services and will communicate this to the Client prior to engagement.',
    },
    {
      number: '04',
      title: 'Confidentiality of Proprietary Process',
      body: "The tools, software, platforms, and methodologies utilized by Yasmine Creates in the design and development of websites are proprietary and strictly confidential. The Company is under no obligation to disclose, discuss, or share any aspect of its build process with the Client at any time. Inquiries regarding the Company's tools or processes will be grounds for immediate termination of the project without refund of any payments made.",
    },
    {
      number: '05',
      title: 'Hosting Activation',
      body: "Hosting does not activate until the Client's website has been fully completed, approved, and officially marked as ready to go live by Yasmine Creates. Upon the website being marked live, the Client's selected hosting plan will activate and recurring billing will commence accordingly.",
    },
    {
      number: '06',
      title: 'No Inactive Websites',
      body: 'Yasmine Creates does not design or deliver websites that will not be actively hosted and maintained. The Company will not build a website that is not intended to go live. Any Client who does not intend to maintain an active hosting plan upon completion is ineligible for services.',
    },
  ];

  return (
    <div className="min-h-screen bg-white font-body flex flex-col">
      {/* Header */}
      <header className="bg-[#1a1a1a] relative overflow-hidden">
        {/* Gold accent line */}
        <div className="absolute top-0 left-0 w-1 h-full bg-[#F5C518]"></div>
        {/* Subtle grid */}
        <div className="absolute inset-0 opacity-[0.03]" style={{ backgroundImage: 'linear-gradient(rgba(255,255,255,0.1) 1px, transparent 1px), linear-gradient(90deg, rgba(255,255,255,0.1) 1px, transparent 1px)', backgroundSize: '60px 60px' }}></div>

        <div className="relative z-10 max-w-3xl mx-auto px-6 sm:px-10 py-12 sm:py-16">
          <button
            onClick={() => navigate('/')}
            className="flex items-center gap-2 text-white/40 hover:text-[#F5C518] text-xs tracking-widest uppercase mb-10 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line text-sm"></i>
            Back to Home
          </button>

          <p className="text-[#F5C518] text-xs tracking-[0.25em] uppercase font-medium mb-3">Legal</p>
          <h1 className="font-display text-white text-4xl sm:text-5xl tracking-wide leading-tight mb-3">
            TERMS &amp; CONDITIONS
          </h1>
          <p className="text-white/40 text-sm">Website Design &amp; Hosting Services — Yasmine Creates</p>
        </div>
      </header>

      {/* Content */}
      <main className="flex-1 max-w-3xl mx-auto w-full px-6 sm:px-10 py-14">
        <div className="space-y-10">
          {sections.map((s) => (
            <div key={s.number} className="flex gap-6 sm:gap-10 group">
              {/* Number */}
              <div className="pt-0.5 shrink-0">
                <span className="font-display text-[#F5C518] text-lg tracking-widest">{s.number}</span>
              </div>
              {/* Text */}
              <div className="border-t border-[#eee] pt-4 flex-1">
                <h2 className="text-[#1a1a1a] font-semibold text-base mb-3 tracking-wide">{s.title}</h2>
                <p className="text-[#666] text-sm leading-relaxed">{s.body}</p>
              </div>
            </div>
          ))}
        </div>

        {/* Last updated */}
        <div className="mt-14 pt-6 border-t border-[#eee] flex items-center justify-between">
          <p className="text-xs text-[#bbb] tracking-wide">
            Last updated:{' '}
            {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}
          </p>
          <span className="font-display text-xs tracking-[0.15em] text-[#ccc]">YASMINE CREATES</span>
        </div>
      </main>

      {/* Footer */}
      <footer className="bg-[#FAFAF8] border-t border-[#eee]">
        <div className="max-w-3xl mx-auto px-6 sm:px-10 py-8 flex flex-col sm:flex-row items-center justify-between gap-4">
          <span className="font-display text-sm tracking-[0.1em] text-[#1a1a1a]">YASMINE CREATES</span>
          <p className="text-xs text-[#999]">&copy; 2025 Yasmine Creates. All rights reserved.</p>
        </div>
      </footer>
    </div>
  );
}
